<template>
  <main class="content">
    <h2><em>Oops, it looks like the page you're looking for doesn't exist !</em></h2>
  </main>
</template>

<script>
export default {
  name: 'NotFound.vue',
};
</script>

<style scoped>
div {
  text-align: center;
}
</style>
